import { FC, FormEvent } from 'react';
import BackNextButtons from 'components/BackNextButtons';
import PersonalInfo from 'components/forms/PersonalInfo/NonSSN';
import RealNameInfo from 'components/forms/RealNameInfo';
import type { OCRFormutil } from 'modules/Open/type';
import values from 'stores/values';
import { IS_TUPSDK } from 'utils/constants';
import { reportEventList } from 'utils/gtag';
import withProgressForm, { ProgressFormProps } from 'utils/withProgressForm';
import { useCustomerInfoFromBridge } from '../../hook';

const BaseInfo: FC<ProgressFormProps> = ({ onSubmit, $formutil }) => {
    const {
        $params: { id_type: formIdType, country: formCountry }
    } = $formutil;
    const { data: dataBridgeCustomer } = useCustomerInfoFromBridge();
    const { legal_residence_country, tax_residence_country } = values.getParams<OCRFormutil>();

    const handleSubmit = (ev: FormEvent) => {
        onSubmit('../baseinfo2', ev);

        reportEventList('personalInfo');
    };

    return (
        <form noValidate onSubmit={handleSubmit}>
            <h3 className="open-title mt-0">{__('PERSONAL INFORMATION')}</h3>
            {/* TUPSDK，且已经有默认数据，则不可编辑 */}
            <RealNameInfo
                idType={formIdType}
                country={formCountry}
                disabled={Boolean(IS_TUPSDK && dataBridgeCustomer?.first_name && dataBridgeCustomer.last_name)}
            />
            <PersonalInfo
                type="baseinfo"
                birthdayProps={{
                    // TUPSDK，且已经有默认数据，则不可编辑
                    disabled: Boolean(IS_TUPSDK && dataBridgeCustomer?.birthday)
                }}
                idNumberProps={{
                    maskIdNo: null,
                    idType: formIdType,
                    // TUPSDK，且已经有默认数据，则不可编辑
                    disabled: Boolean(IS_TUPSDK && dataBridgeCustomer?.id_no)
                }}
                countryProps={{
                    isSSN: false,
                    disabled: true
                }}
                legalResidenceCountry={legal_residence_country}
                taxResidenceCountry={tax_residence_country}
            />
            <BackNextButtons sticky />
        </form>
    );
};

export default withProgressForm({
    step: 0.5,
    id: 'baseinfo',
    basePath: 'open',
    ensure: 'account',
    showProgressBar: true,
    eventParams: {
        exposureEventParams: {
            model: '开户-基础信息',
            name: '基础信息-页面曝光'
        },
        submitEventParams: {
            model: '开户-基础信息',
            name: '基础信息-点击下一步'
        }
    }
})(BaseInfo);
